<template>
  <div class="ydw-main">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="年度危废信息" name="年度危废信息">
        <span class="title">年度危废信息</span>
        <div class="year-wf">
          <div class="operate-btns">
            <!-- <el-button size="mini" v-auth="'Company'" @click="add()">添加危废信息</el-button> -->
          </div>
          <el-table
            :header-cell-style="{
              background: '#f5f5f5',
            }"
            :data="dangerWasters"
            height="calc(100% - 70px)"
            border
            style="width: 100%"
          >
            <el-table-column
              align="center"
              label="序号"
              type="index"
              width="50"
            >
              <template scope="scope">
                <span>{{
                  (pagination.current - 1) * pagination.pageSize +
                  scope.$index +
                  1
                }}</span>
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="dangerWasterList.name"
              label="危废名称"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="dangerWasterList.type"
              label="危险废物类别"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="dangerWasterList.code"
              label="危险废物代码"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="yearPlanOutPut"
              label="本年度计划产生量（吨）"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="yearPlanDisPosVol"
              label="本年度计划处置量（吨）"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="isTransProvince"
              label="是否跨省转移"
            >
              <template slot-scope="{ row }">
                {{ row.isTransProvince ? "是" : "否" }}
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              prop="receptionPlace"
              label="接受地"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="handleCompany.name"
              label="处置单位"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="handleTypeText"
              label="处置方式"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="serviceStartDate"
              label="服务时间"
            >
              <template slot-scope="{ row }">
                {{
                  formatServiceDate(row.serviceStartDate, row.serviceEndDate)
                }}
              </template>
            </el-table-column>

            <el-table-column
              align="center"
              label="操作"
              width="120"
              v-if="!companyId"
            >
              <template slot-scope="{ row }">
                <!-- <el-button type="text" style="color: #f56c6c" size="mini" @click="deleteDw(row.id)">删除</el-button>
                <el-divider direction="vertical"></el-divider> -->
                <el-button type="text" size="mini" @click="edit(row)"
                  >修改</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="paaination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.current"
              :page-sizes="pagination.pageSizeOptions"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
          <!-- <a-table bordered :resizeable="true" :rowKey="(record) => record.id" :pagination="pagination"
            :columns="dangerWasterInfoColumns" :data-source="dangerWasters" :scroll="{ y: 700 }" @showSizeChange="onPage"
            @change="({ current, pageSize }) => {
              onPage(current, pageSize);
            }
              ">
            <div slot="actions" v-auth="'Company'" slot-scope="text, record">
              <el-button type="text" style="color: #f56c6c" size="mini" @click="deleteDw(record.id)">删除</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" size="mini" @click="edit(record)">修改</el-button>
            </div>
          </a-table> -->
        </div>
      </el-tab-pane>
      <el-tab-pane label="佐证材料" name="佐证材料">
        <span class="title">佐证材料</span>
        <div class="file-list">
          <el-radio-group v-model="tabs" size="small" @change="tabChange(tabs)">
            <el-radio-button label="处置合同"></el-radio-button>
            <el-radio-button label="跨省转移手续"></el-radio-button>
          </el-radio-group>
          <keep-alive>
            <component v-bind:is="tabView" style="width: 100%; height: 100%">
            </component>
          </keep-alive>
        </div>
      </el-tab-pane>
    </el-tabs>
    <addDangerWaster
      ref="addDangerWaster"
      :dealWithCompanies="dealWithCompanies"
      :wfList="wfList"
      :handleType="handleType"
    >
    </addDangerWaster>
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";
import addDangerWaster from "./components/addDangerWaster.vue";
import handleFiles from "./components/handleFiles.vue";
import transProvinceFiles from "./components/transProvinceFiles.vue";
export default {
  components: { addDangerWaster, handleFiles, transProvinceFiles },
  props: {
    companyId: {
      default: 0,
    },
  },
  watch: {
    companyId(val) {
      this.getYearDangerWasters();
    },
  },
  data() {
    const dangerWasterInfoColumns = [
      {
        title: "序号",
        align: "center",
        width: 70,
        customRender: (text, record, index) => {
          const { current, pageSize } = this.pagination;
          return (current - 1) * pageSize + index + 1;
        },
      },
      {
        title: "危废名称",
        dataIndex: "dangerWasterList.name",
        key: "name",
        align: "center",
      },
      {
        title: "危险废物类别",
        dataIndex: "dangerWasterList.type",
        key: "type",
        align: "center",
      },
      {
        title: "危险废物代码",
        dataIndex: "dangerWasterList.code",
        key: "code",
        align: "center",
      },
      {
        title: "本年度计划产生量（吨）",
        dataIndex: "yearPlanOutPut",
        key: "yearPlanOutPut",
        align: "center",
      },
      {
        title: "本年度计划处置量（吨）",
        dataIndex: "yearPlanDisPosVol",
        key: "yearPlanDisPosVol",
        align: "center",
      },
      {
        title: "是否跨省转移",
        dataIndex: "isTransProvince",
        key: "isTransProvince",
        align: "center",
        width: 120,
        customRender: (text, record, index) => (text ? "是" : "否"),
      },
      {
        title: "接受地",
        dataIndex: "receptionPlace",
        key: "receptionPlace",
        align: "center",
        width: 120,
      },
      {
        title: "处置单位",
        dataIndex: "handleCompany.name",
        key: "handleCompanyName",
        align: "center",
      },
      {
        title: "处置方式",
        dataIndex: "handleType",
        key: "handleType",
        align: "center",
        customRender: (text, record, index) => {
          let t = this.handleType.find((h) => h.value === text);
          return t.name + " " + t.description;
        },
      },
      {
        title: "服务时间",
        dataIndex: "serviceStartDate",
        key: "serviceStartDate",
        align: "center",
        customRender: (text, record, index) => {
          let res = "";
          if (text) {
            const startDate = this.$dayjs(record.serviceStartDate).format(
              "YYYY-MM-DD"
            );
            const endDate = this.$dayjs(record.serviceEndDate).format(
              "YYYY-MM-DD"
            );
            res = startDate + " 至 " + endDate;
          }
          return res;
        },
      },
      {
        title: "操作",
        key: "operation",
        fixed: "right",
        width: 100,
        align: "center",
        scopedSlots: { customRender: "actions" },
      },
    ];
    return {
      activeName: "年度危废信息",
      dangerWasterInfoColumns,
      dangerWasters: [],
      handleType: [],

      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
      // pagination: {
      //   current: paginations.page,
      //   pageSize: paginations.limit,
      //   total: paginations.total,
      //   showSizeChanger: true,
      //   hideOnSinglePage: false,
      //   showQuickJumper: true,
      //   pageSizeOptions: paginations.pageSizesOption,
      //   showTotal: (total) => `一共${total}条记录 `,
      // },
      wfList: [],
      dealWithCompanies: [],
      tabs: "处置合同",
      tabView: "handleFiles",
    };
  },
  computed: {},
  methods: {
    formatServiceDate(startDate, endDate) {
      let res = "";
      if (startDate) {
        res =
          this.$dayjs(startDate).format("YYYY-MM-DD") +
          " 至 " +
          this.$dayjs(endDate).format("YYYY-MM-DD");
      }
      return res;
    },
    tabChange(tab) {
      // this.tabView = tab;
      if ("处置合同" == tab) {
        this.tabView = "handleFiles";
      } else if ("跨省转移手续" == tab) {
        this.tabView = "transProvinceFiles";
      }
    },
    getYearDangerWasters() {
      const params = {
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };

      if (this.companyId) params.companyId = this.companyId;
      let url = this.$api.dangerWasters.getDangerWasters;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { dangerWasters, handleType, total, wfList, dealWithCompanies } =
            res.data.data;
          this.dangerWasters = dangerWasters;
          this.handleType = handleType;
          this.pagination.total = total;
          this.wfList = wfList;
          this.dealWithCompanies = dealWithCompanies;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    //添加
    add() {
      this.$refs.addDangerWaster.lookUserDrawerOpen();
    },
    edit(row) {
      this.$refs.addDangerWaster.lookUserDrawerOpen(row);
    },
    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getYearDangerWasters();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getYearDangerWasters();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getYearDangerWasters();
    },
    deleteDw(id) {
      this.$confirm("此操作将永久删除此项, 是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let url = this.$api.dangerWasters.delete + "/" + id;
        this.$axios.del(url, false).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getYearDangerWasters();
          } else {
            this.$message({
              message: "加载数据失败，请重试",
              type: "error",
            });
          }
        });
      });
    },
  },

  mounted() {
    this.getYearDangerWasters();
  },
};
</script>

<style lang="scss" scoped>
.ydw-main {
  height: 100%;

  .el-tabs {
    width: 100%;
    height: 100%;

    /deep/.el-tabs__content {
      height: calc(100% - 55px);

      .el-tab-pane {
        height: 100%;
      }
    }
  }
}

.year-wf {
  height: calc(100% - 50px);
  padding: 0px 50px 10px 50px;
}

.file-list {
  padding: 10px 50px;
  height: calc(100% - 28px);
}

.dialog-form {
  padding: 0px 20px;
}

.operate-btns {
  margin: 5px 0px;
}

.paaination {
  margin-top: 16px;
  text-align: right;
}

.title {
  font-size: 18px;
  font-weight: bold;
  border-left: 8px solid #1890ff;
  padding-left: 12px;
}
</style> 